import { LINK_ROW_SPAN } from '@/pages/collection/[id]';
import { colorManagerAtom } from '@/store/uiStore';
import clsx from 'clsx';
import { useAtom } from 'jotai';
import React from 'react';

interface AddLinkBlockProps {
  onClick: () => void;
}
export default function AddLinkBlock({ onClick }: AddLinkBlockProps) {
  const [colorManager] = useAtom(colorManagerAtom);

  return (
    <div
      className={clsx([
        'grid justify-center content-center border border-[#ABABAB] border-dashed cursor-pointer text-center gap-1',
        colorManager.text,
      ])}
      style={{ gridRow: `span ${LINK_ROW_SPAN}` }}
      onClick={onClick}
    >
      <span className="font-adieu font-light text-[32px] leading-none transform translate-y-[-6px]">
        +
      </span>
      <span className="font-adieu font-light text-[14px] leading-[100%] tracking-[0.15em]">
        ADD LINK
      </span>
    </div>
  );
}
